import useFooterStore from "views/hooks/useFooterStore";
import { Card, Col, Form, Input, InputNumber, Row } from "antd";
import { useTranslation } from "react-i18next";
import CardTitle from "components/CardTitle";
import { FaListAlt } from "react-icons/fa";
import Counterpart from "components/Counterpart";
import { useWatch } from "antd/lib/form/Form";
import type { FormInstance } from "antd";
import type { AccountingTransferFormValues } from "../utils";

interface AccountParametersFormValues {
  prefixClientAccount: string;
  prefixProviderAccount: string;
  collectiveClientAccount: string;
  collectiveProviderAccount: string;
  generalAccountsLength: number;
  thirdPartiesAccountsLength: number;
}

interface BillingTransferNoAccountingPropsType {
  onFinish: (values: AccountingTransferFormValues) => void | Promise<void>;
  form: FormInstance<AccountingTransferFormValues>;
  accountingSettingsForm: FormInstance<AccountParametersFormValues>;
}

export default function BillingTransferNoAccounting(
  props: BillingTransferNoAccountingPropsType,
): React.ReactElement {
  const { form, onFinish, accountingSettingsForm } = props;

  const generalAccountsLength = useWatch("generalAccountsLength", accountingSettingsForm);

  const { t } = useTranslation();
  const setHandleOkSaveButton = useFooterStore(state => state.setHandleOkSaveButton);
  const setSaveLoading = useFooterStore(state => state.setSaveLoading);

  const onFinishFailed = ({
    errorFields,
  }: {
    errorFields: { name: (string | number)[]; errors: string[] }[];
  }) => {
    if (errorFields) {
      setHandleOkSaveButton(false);
      setSaveLoading(false);
    }
  };

  return (
    <Form
      name="updateCompany"
      onFinishFailed={onFinishFailed}
      layout="vertical"
      form={form}
      onFinish={onFinish}
      autoComplete="off"
    >
      <Form.Item name="allowAccountCreationsInSsi" hidden>
        <Input />
      </Form.Item>
      <Card
        title={<CardTitle icon={<FaListAlt />} title={t("Default Counterparts")} />}
        className="antd-newrai-card"
      >
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item label={t("Sell book")} name="sellBookCode">
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label={t("Client counterpart")} name="clientCounterpartAccount">
              <Counterpart />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={t("Advance payment issued counterpart")}
              name="advancePaymentIssuedCounterpart"
            >
              <InputNumber maxLength={generalAccountsLength} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={t("Advance payment received counterpart")}
              name="advancePaymentReceivedCounterpart"
            >
              <InputNumber maxLength={generalAccountsLength} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={t("Advance payment issued tva counterpart")}
              name="advancePaymentIssuedTvaCounterpart"
            >
              <InputNumber maxLength={generalAccountsLength} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={t("Advance payment received tva counterpart")}
              name="advancePaymentReceivedTvaCounterpart"
            >
              <InputNumber maxLength={generalAccountsLength} />
            </Form.Item>
          </Col>
        </Row>
      </Card>
    </Form>
  );
}
